export default function ContactSection() {
  return (
    <section id="contact" className="bg-[#FAF8F5] py-24 px-6 md:px-12">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col items-start">
          {/* Info */}
          <div className="w-full max-w-2xl">
            <p className="text-[#FF6B35] text-xs font-semibold tracking-[0.25em] uppercase mb-3">Contact Us</p>
            <h2 className="text-[#1A1A1A] font-extrabold text-4xl md:text-5xl mb-6 leading-tight">
              Get in <span className="text-[#8B6F47]">Touch</span>
            </h2>
            <p className="text-[#1A1A1A]/60 text-base leading-relaxed mb-10">
              Have a question, want to make a reservation, or just want to say hello? We&apos;d love to hear from you.
            </p>

            <div className="flex flex-col gap-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35]/10 rounded-xl shrink-0">
                  <i className="ri-map-pin-line text-[#FF6B35] text-xl" />
                </div>
                <div>
                  <p className="text-[#1A1A1A] font-bold text-sm mb-1">Address</p>
                  <p className="text-[#1A1A1A]/60 text-sm leading-relaxed">Landvegamót, Route 1<br />851 Hella, South Iceland</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35]/10 rounded-xl shrink-0">
                  <i className="ri-phone-line text-[#FF6B35] text-xl" />
                </div>
                <div>
                  <p className="text-[#1A1A1A] font-bold text-sm mb-1">Phone</p>
                  <a href="tel:+3544878440" className="text-[#1A1A1A]/60 text-sm hover:text-[#FF6B35] transition-colors">+354 487 8440</a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35]/10 rounded-xl shrink-0">
                  <i className="ri-mail-line text-[#FF6B35] text-xl" />
                </div>
                <div>
                  <p className="text-[#1A1A1A] font-bold text-sm mb-1">Email</p>
                  <a href="mailto:gallery@simnet.is" className="text-[#1A1A1A]/60 text-sm hover:text-[#FF6B35] transition-colors">gallery@simnet.is</a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35]/10 rounded-xl shrink-0">
                  <i className="ri-time-line text-[#FF6B35] text-xl" />
                </div>
                <div>
                  <p className="text-[#1A1A1A] font-bold text-sm mb-1">Opening Hours</p>
                  <p className="text-[#1A1A1A]/60 text-sm">Open Daily: 11:30 – 21:00</p>
                </div>
              </div>
            </div>

            {/* Social */}
            <div className="flex gap-3 mt-10">
              {[
                { icon: "ri-instagram-line", href: "https://www.instagram.com/gallerypizzahvollywood?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" },
                { icon: "ri-facebook-line", href: "https://facebook.com/gallerypizza" },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center border border-[#1A1A1A]/15 rounded-full text-[#1A1A1A]/60 hover:border-[#FF6B35] hover:text-[#FF6B35] transition-colors duration-200 cursor-pointer"
                >
                  <i className={`${s.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
